import { GalleryConfig } from 'rangeConfig/@types';

const ivarGalleryConfig: GalleryConfig = {
  default: [
    {
      sprs: [
        { id: 'SPR-69389814' },
        { id: 'SPR-19403817' },
        { id: 'SPR-99470214' },
        { id: 'SPR-59572568' },
        { id: 'SPR-29507881' },
        { id: 'SPR-89507883' },
        { id: 'SPR-09403950' },
        { id: 'SPR-39508088' },
        { id: 'SPR-19508089' },
        { id: 'SPR-79248362' },
        { id: 'SPR-69407059' },
        { id: 'SPR-29248538' },
        { id: 'SPR-89407063' },
        { id: 'SPR-69395805' },
        { id: 'SPR-99403470' },
        { id: 'SPR-49248354' },
        { id: 'SPR-89407058' }
      ]
    }
  ]
};

export default ivarGalleryConfig;
